import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./summaryActions";
import * as request from "utility/request";
import { AssetClass } from "types/AssetClass";
import { Summary } from "types/Summary";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadSummary = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<Summary[]>(
        `${apiUrl}/api/summary?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", error));
    }
  };
};

export const loadSummaryByAssetClass = (
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString));

    try {
      const res = await request.getResponseJson<Summary[]>(
        `${apiUrl}/api/summary/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess(assetClassString, res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(assetClassString, error));
    }
  };
};
